// @ts-nocheck
import {
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Modal,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  acceptContractorDocumentAction,
  alertDialogAciton,
  fetchContractorProfileDetailsAction,
  logoutAction,
} from "../../../../../store/actions/auth";
import { useNavigate } from "react-router-dom";
import { ProgressCounter } from "../../../../../components/Custom/stepper/ProgressCounter";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { getContractsForState } from "../../../../../utils/methods/contract/contractMethods";
import PropTypes from "prop-types";
import { CONTRACTOR_CONTRACT_UPDATED_AT } from "../../../../../utils/constants/urls";
import { Check, Close, Download, ZoomIn, ZoomOut } from "@mui/icons-material";
import { getCssVariableHandler } from "../../../../../utils/styles/getCssVariables";
import {
  CustomIconButton,
  CustomIconButtonForSheet,
} from "../../../../../components/Custom/CustomIconButton";
import { Document, Page, pdfjs } from "react-pdf";
import pdfWorkerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";
import LoadingOverlay from "../../../../../components/Custom/LoadingOverlay";
import { fetchContractorDocumentUrls } from "../../../../../store/actions/config/contractorLink";
import { pdfApiRequest } from "../../../../../services/pdfApiService";
import dayjs from "dayjs";
import { isUserRole, isActiveRole } from "../../../../../utils/methods/storeFunc";
import { USER_ROLES } from "../../../../../staticData/userRoles";

// pdf.js worker — configured here with Vite's `?url` (which bundles a real asset)
// so react-pdf can render. The prior `new URL("pdfjs-dist/...", import.meta.url)`
// in RightContract did NOT resolve to a real file in the prod build, so the worker
// failed to load and PDFs (View Contracts, agreements) rendered blank everywhere.
pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

// NOTE: style for modal
const style = {
  m: "auto",
  width: 400,
  boxShadow: 24,
  p: 4,
  minWidth: "700px",
  minHeight: "400px",
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
  position: "relative",
  "@media (max-width: 600px)": {
    minWidth: "96vw",
    maxHeight: "96vh",
    width: "97vw",
    overflowY: "auto",
  },
};

const fabStyle = {
  width: "44px",
  height: "44px",
  borderRadius: "50%",
  backgroundColor: "#D175B6",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  transition: "background-color 0.15s ease, transform 0.15s ease",
  "&:hover": {
    backgroundColor: "#e490cc",
    transform: "scale(1.08)",
  },
};

export const DocAndContracts = ({
  contractorId,
  isParentWraperEnabled = true,
  readOnly = false,
  currentDocument,
  hideTitle = false,
  removePadding = false,
}) => {
  const initialPdfState = useMemo(() => {
    return {
      state: false,
      readOnly: false,
      selectedPdf: null,
    };
  }, []);

  const { loading, contractorType, userId } = useSelector(
    (state) => state?.auth,
  );
  const { contractorPDFUrls, contractorPdfLoading, contractorPdfStatus } = useSelector(
    (state) => state?.contractorLink,
  );
  const [contracts, setContracts] = useState(readOnly ? currentDocument : null);
  const [viewPdf, setViewPdf] = useState(initialPdfState);
  const [downloadLoading, setDownloadLoading] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  useEffect(() => {
    if (!contractorPdfStatus || contractorPdfStatus === "idle") {
      dispatch(fetchContractorDocumentUrls());
    }
  }, [contractorPdfStatus, dispatch]);

  function submitHandler() {
    // handle the submittion
    let payload = {};
    contracts?.forEach((con) => {
      payload = {
        ...payload,
        [`${con?.type}Url`]: con?.url,
        [`${con?.type}Consent`]: con?.isAccepted,
      };
    });

    dispatch(
      acceptContractorDocumentAction({
        payload: {
          params: {
            userId: contractorId,
          },
          data: payload,
        },
        successCallback: () => {
          if (isActiveRole(USER_ROLES.CONTRACTOR)) {
            dispatch(
              fetchContractorProfileDetailsAction({
                payload: {
                  contractorId: userId,
                },
              }),
            );
          }
        },
      }),
    );
  }

  const acceptedDocuments = contracts?.filter((c) => c?.isAccepted)?.length;

  const totalDocuments = useMemo(() => {
    return contracts?.length || 0;
  }, [contracts]);

  /**
   * 🔴 Quem pode ACEITAR aqui: só o próprio dono do perfil.
   *
   * Antes, `readOnly` decidia sozinho, e ele é `true` fixo nos dois lugares onde o
   * contractor vê os próprios documentos (step 5 do wizard e a seção do Profile).
   * Resultado: o documento abria sem checkbox e não havia NENHUMA tela onde aceitar,
   * porque a única que aceita (`LayoutContractor.jsx:137`) só monta enquanto
   * `!isAgreementAccepted` — e essa flag é trava de mão única. Quem tivesse a flag
   * ligada sem registro (48 contas em prod, 03/08) ficava preso vendo "Not Accepted".
   *
   * ⚠️ NÃO usar `!readOnly`: `readOnly` também é o modo do ADMIN olhando o perfil de
   * outra pessoa (`DocAndContractsViewer`, `AddContractorCongratulations`). Aceitar
   * documento jurídico no lugar do contractor seria pior que o bug. Por isso a
   * condição é a identidade, não o modo da tela.
   */
  const isOwnProfile =
    !!contractorId && !!userId && String(contractorId) === String(userId);
  const pendentes = totalDocuments - (acceptedDocuments || 0);

  /**
   * 🔴 Marcações feitas AGORA e ainda não gravadas.
   *
   * `contracts` começa igual ao `currentDocument` (o que veio do servidor) e diverge
   * conforme a pessoa marca os checkboxes. A diferença entre os dois é o que ainda
   * não foi salvo.
   *
   * Isso existe porque a 1ª versão condicionava o botão a `pendentes > 0`: ao marcar
   * o ÚLTIMO documento os pendentes viravam zero e o botão de salvar SUMIA — bem na
   * hora de usar. Testado no dev-app em 03/08: aceitei os 8, recarreguei, e tudo
   * tinha voltado pra "Not Accepted". Não dá pra medir "falta salvar" por
   * "falta aceitar": são coisas diferentes.
   */
  const naoSalvos = (contracts ?? []).filter((c, i) => {
    const original = Array.isArray(currentDocument) ? currentDocument[i] : null;
    return !!c?.isAccepted !== !!original?.isAccepted;
  }).length;

  const podeAceitarAqui = isOwnProfile && (pendentes > 0 || naoSalvos > 0);

  async function handleDownload(url, title, isAccepted, pdfType) {
    if (!isAccepted) {
      const a = document.createElement("a");
      a.href = url;
      a.download = title ? `${title}.pdf` : "document.pdf";
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      setDownloadLoading(title);
      await pdfApiRequest({
        method: "POST",
        url: "contract",
        data: {
          pdfType,
          contractorId,
        },
      });
      setDownloadLoading(null);
    }
  }

  const continueClickHandler = useCallback(
    ({ nextIdx }) => {
      const obj = contracts?.[nextIdx] || null;
      if (obj) {
        setViewPdf({
          state: true,
          selectedPdf: obj,
          index: nextIdx,
          readOnly: false,
        });
      } else {
        setViewPdf(initialPdfState);
      }
    },
    [contracts, initialPdfState],
  );

  useEffect(() => {
    if (readOnly) return;
    if (Object.keys(contractorPDFUrls)?.length > 0) {
      setContracts(getContractsForState({ contractorType, contractorPDFUrls }));
    }
  }, [contractorPDFUrls, contractorType, readOnly]);

  useEffect(() => {
    if (readOnly) {
      setContracts(currentDocument);
    }
  }, [currentDocument, readOnly]);

  return (
    <DocAndContracts.ParentWrapper
      isParentWraperEnabled={isParentWraperEnabled}
      submitHandler={submitHandler}
      isDisabled={totalDocuments != acceptedDocuments}
    >
      {contractorPdfStatus === "error" ? (
        <Alert severity="error" action={
          <Button color="inherit" size="small" onClick={() => dispatch(fetchContractorDocumentUrls())}>
            Retry loading contracts
          </Button>
        }>
          Could not load standard contract documents.
        </Alert>
      ) : contractorPdfLoading || loading ? (
        <Box role="status" sx={{ display: "flex", alignItems: "center", gap: 2, py: 3 }}>
          <CircularProgress size={24} color="secondary" />
          <Typography>Loading contracts…</Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            flexDirection: "column",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          {hideTitle ? null : (
            <Typography fontSize="1.5rem" fontWeight={500}>
              {"Documents and Contracts"}
            </Typography>
          )}

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              flexDirection: "column",
              gap: "1rem",
              position: "relative",
              width: "100%",
              padding: removePadding
                ? "0px"
                : isSmallScreen
                  ? "1rem"
                  : "1rem 2rem",
            }}
          >
            {/* NOTE: progress counter */}
            {readOnly ? null : (
              <Box
                sx={{
                  textAlign: "right",
                  position: "absolute",
                  right: isSmallScreen ? "1rem" : "1.75rem",
                }}
              >
                <ProgressCounter
                  totalCount={totalDocuments}
                  currentCount={acceptedDocuments}
                />
              </Box>
            )}
            {/* NOTE: listing of all the contracts */}
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                gap: "2rem",
                marginTop: removePadding ? "0rem" : "3rem",
              }}
            >
              {/* `isNull(contracts)` only caught an EXPLICIT null. When
                  `getContractorAgreementState` bails out (contractorType
                  outside AGREEMENT_CONTRACTOR_TYPES, or PDF template list not
                  loaded yet) it returns `undefined`, which slipped past this
                  check AND past the `.map()` below — so the modal rendered
                  completely blank, with no message at all. */}
              {!contracts?.length ? (
                <Typography>No Documents Found</Typography>
              ) : null}
              {contracts?.map((con, i) => {
                return (
                  <Box
                    key={i}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "2rem",
                      width: "100%",
                    }}
                  >
                    {/* NOTE: left side */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        gap: "0.25rem",
                        flexDirection: "column",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "1rem",
                          fontWeight: "400",
                        }}
                      >
                        {con?.title}
                      </Typography>
                      {readOnly && con?.isAccepted ? (
                        <Typography
                          sx={{
                            fontSize: "0.8rem",
                            fontWeight: "300",
                            color: "grey",
                          }}
                        >{`Accepted On ${dayjs(con?.consentedAt)?.format("MM/DD/YYYY")}`}</Typography>
                      ) : (
                        <Typography
                          sx={{
                            fontSize: "0.8rem",
                            fontWeight: "300",
                            color: "grey",
                          }}
                        >{`Updated On ${con?.updatedOn || CONTRACTOR_CONTRACT_UPDATED_AT}`}</Typography>
                      )}
                      {con?.isExpired && (
                        <Typography
                          sx={{
                            fontSize: "0.8rem",
                            fontWeight: "300",
                            color: "grey",
                          }}
                        >{`Expired On ${dayjs(con?.expiresAt)?.format("MM/DD/YYYY")}`}</Typography>
                      )}
                    </Box>

                    {/* NOTE: right side */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      {con?.isAccepted ? (
                        <Tooltip title={"Accepted"}>
                          <Check
                            sx={{
                              color: getCssVariableHandler({
                                variableName: "--primary-green-shade2-hex",
                              }),
                            }}
                          />
                        </Tooltip>
                      ) : (
                        <Tooltip title={"Not Accepted"}>
                          <Close
                            sx={{
                              color: getCssVariableHandler({
                                variableName: "--red-shade-1-hex",
                              }),
                            }}
                          />
                        </Tooltip>
                      )}
                      <Button
                        sx={{
                          padding: "0.25rem 0.5rem",
                          borderRadius: "0.5rem",
                          background: "#171717",
                          ...(con?.isAccepted
                            ? {
                                borderColor: "#1F2020",
                              }
                            : {
                                borderColor: getCssVariableHandler({
                                  variableName: "--primary-pink-hex",
                                }),
                                color: getCssVariableHandler({
                                  variableName: "--primary-pink-hex",
                                }),
                              }),
                        }}
                        onClick={() => {
                          const obj = {
                            state: true,
                            selectedPdf: con,
                            index: i,
                          };
                          // abre em modo de aceite quando o documento ainda não foi
                          // aceito E é o próprio dono olhando (ver isOwnProfile)
                          obj.readOnly = !!con?.isAccepted || !isOwnProfile;
                          setViewPdf(obj);
                        }}
                      >
                        {con?.isAccepted
                          ? readOnly
                            ? "View Document"
                            : "View/Review"
                          : isOwnProfile
                            ? "Review & Accept"
                            : "View Document"}
                      </Button>
                      {readOnly && (
                        <CustomIconButton
                          sx={{
                            borderRadius: "50%",
                            backgroundColor: getCssVariableHandler({
                              variableName: "--primary-pink-hex",
                            }),
                            "&:hover": {
                              backgroundColor: getCssVariableHandler({
                                variableName: "--primary-pink-hex",
                              }),
                              opacity: "0.8",
                            },
                          }}
                          onClick={() => {
                            handleDownload(
                              con?.url,
                              con?.title,
                              con?.isAccepted,
                              con?.matchToKey,
                            );
                          }}
                        >
                          {downloadLoading == con?.title ? (
                            <CircularProgress size={20} />
                          ) : (
                            <Download
                              sx={{ color: "#fff", fontSize: "1.2rem" }}
                            />
                          )}
                        </CustomIconButton>
                      )}
                    </Box>
                  </Box>
                );
              })}
            </Box>
            {/*
              O botão de gravar vive no ParentWrapper, que SÓ é renderizado no gate
              (`isParentWraperEnabled`). Nas telas onde o contractor vê o próprio
              perfil o wrapper não existe, então marcar o checkbox não gravava nada.
              Este botão fecha esse buraco. Fica desabilitado até TODOS estarem
              marcados, igual à regra do gate (`isDisabled={total != aceitos}`) e à
              do backend, que recusa aceite parcial.
            */}
            {!isParentWraperEnabled && podeAceitarAqui ? (
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: "1rem",
                  paddingTop: "1rem",
                }}
              >
                <Typography sx={{ fontSize: "0.85rem", color: "grey" }}>
                  {pendentes > 0
                    ? `${pendentes} document${pendentes > 1 ? "s" : ""} pending acceptance`
                    : "Not saved yet"}
                </Typography>
                <Button
                  className="btn-pink"
                  disabled={totalDocuments !== acceptedDocuments}
                  sx={{
                    ...(totalDocuments !== acceptedDocuments
                      ? { cursor: "not-allowed", opacity: "0.6" }
                      : {}),
                  }}
                  onClick={() => {
                    if (totalDocuments === acceptedDocuments) submitHandler();
                  }}
                >
                  Save acceptance
                </Button>
              </Box>
            ) : null}
          </Box>
          {viewPdf?.state ? (
            <DocAndContracts.ContractAcceptModal
              /*
                🔴 `key` por documento: força REMONTAGEM ao avançar pelo Continue.
                Sem ele o estado interno vaza entre documentos — verificado no
                dev-app em 03/08: aceita o 1º, clica Continue, e o 2º já aparece
                com o checkbox MARCADO e sem o gate de rolagem. Dá pra "assinar"
                os 8 tendo lido um. Abrir cada documento pela lista reseta certo,
                então é só no encadeamento.
                Isso é ANTERIOR a este fix e vale pro gate que os contractors
                novos usam hoje em produção — não foi introduzido aqui.
                Remontar é mais seguro que confiar no useEffect de reset: não há
                estado a esquecer quando alguém adicionar outro campo ao modal.
              */
              key={viewPdf?.index ?? viewPdf?.selectedPdf?.matchToKey}
              open={viewPdf?.state}
              titleName={viewPdf?.selectedPdf?.title}
              pdfUrl={viewPdf?.selectedPdf?.url}
              isAccepted={viewPdf?.selectedPdf?.isAccepted}
              onClose={() => {
                setViewPdf(initialPdfState);
              }}
              readOnly={viewPdf?.readOnly}
              fetchPdfFromNextJs={readOnly}
              contractorId={contractorId}
              pdfType={viewPdf?.selectedPdf?.matchToKey}
              updateCheckboxClick={(value) => {
                setContracts((prevContracts) =>
                  prevContracts.map((contract, idx) =>
                    idx === viewPdf?.index
                      ? { ...contract, isAccepted: value }
                      : contract,
                  ),
                );
              }}
              continueClickHandler={() => {
                continueClickHandler({ nextIdx: viewPdf?.index + 1 });
              }}
            />
          ) : null}
        </Box>
      )}
    </DocAndContracts.ParentWrapper>
  );
};

DocAndContracts.ParentWrapper = function ParentWrapper({
  isParentWraperEnabled,
  submitHandler,
  children,
  isDisabled,
}) {
  const { loading } = useSelector((state) => state?.auth);
  const { contractorPdfLoading } = useSelector(
    (state) => state?.contractorLink,
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function logoutFunction() {
    dispatch(logoutAction({}));
    navigate("/login");
  }

  if (!isParentWraperEnabled) {
    return children;
  }

  return (
    <Box
      sx={{
        ...style,
      }}
    >
      {children}
      <Box
        sx={{
          ...(loading || contractorPdfLoading ? { display: "none" } : {}),
          "& button": {
            cursor: "pointer",
          },
        }}
        className="bottom-btn-box"
      >
        <Button className="btn-black" onClick={logoutFunction}>
          <Typography className="btn-text">Logout</Typography>
        </Button>
        <Button
          className="btn-pink"
          sx={{
            ...(isDisabled
              ? { cursor: "not-allowed !important", opacity: "0.6" }
              : {}),
          }}
          onClick={() => {
            if (loading || isDisabled) return;
            submitHandler();
          }}
        >
          <Typography className="btn-text">Submit</Typography>
        </Button>
      </Box>
    </Box>
  );
};

DocAndContracts.ContractAcceptModal = function ContractorAcceptModal({
  open,
  titleName,
  pdfUrl,
  updateCheckboxClick,
  isAccepted,
  onClose,
  readOnly,
  fetchPdfFromNextJs,
  pdfType,
  contractorId,
  continueClickHandler,
}) {
  const containerRef = useRef(null);
  const [numPages, setNumPages] = useState(null);
  const [reachedEnd, setReachedEnd] = useState(false);
  const [checkboxStatus, setCheckboxStatus] = useState(isAccepted);
  const [showDownload, setShowDownload] = useState(false);
  const [scale, setScale] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const lastTouchDistRef = useRef(null);
  const [currentPdfUrl, setCurrentPdfUrl] = useState(
    fetchPdfFromNextJs && isAccepted ? null : pdfUrl,
  );
  const dispatch = useDispatch();

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setIsLoading(false);
    setTimeout(() => {
      const el = containerRef.current;
      if (!el) return;
      if (el.scrollHeight <= el.clientHeight) setReachedEnd(true);
    }, 100);
  }

  function handleScroll() {
    const el = containerRef.current;
    if (!el || isLoading) return;
    const isBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 5;
    if (isBottom) setReachedEnd(true);
  }

  function handleCheckboxClick(e) {
    const newValue = e?.target?.checked;
    updateCheckboxClick(newValue);
    setCheckboxStatus(newValue);
  }

  function handleTouchEnd() {
    lastTouchDistRef.current = null;
  }

  function handleDownload() {
    const a = document.createElement("a");
    a.href = currentPdfUrl;
    a.download = titleName ? `${titleName}.pdf` : "document.pdf";
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  async function fetchAndPreparePdf(setPdfUrl, setLoading) {
    try {
      setLoading(true);

      const res = await pdfApiRequest({
        method: "POST",
        url: "contract",
        data: {
          pdfType,
          contractorId,
        },
        returnBlob: true,
      });

      // 🔴 `pdfApiRequest` handles errors and returns null instead of rethrowing.
      // Without this guard, `URL.createObjectURL(undefined)` opened an empty modal
      // with only its title and close button (seen in dev on 2026-08-03 when the
      // PDF service returned 500 from POST /api/contract).
      if (!res?.blob) throw new Error("empty response from pdf-service");

      const url = URL.createObjectURL(res.blob);

      setPdfUrl(url);
    } catch (err) {
      console.error("PDF error:", err);
      // Fall back to the original document (same content without the signature
      // stamp). This is safer than an empty modal, especially for contractors who
      // have no signed copy yet and must read the document before accepting it.
      if (pdfUrl) {
        setPdfUrl(pdfUrl);
        return;
      }
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: "Could not load this document. Please try again.",
        }),
      );
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!fetchPdfFromNextJs) return;
    if (!isAccepted) return;
    if (fetchPdfFromNextJs) {
      fetchAndPreparePdf(setCurrentPdfUrl, setIsLoading);
    }
  }, [fetchPdfFromNextJs]);

  useEffect(() => {
    return () => {
      if (currentPdfUrl?.startsWith("blob:")) {
        URL.revokeObjectURL(currentPdfUrl);
      }
    };
  }, [currentPdfUrl]);

  useEffect(() => {
    setCheckboxStatus(isAccepted);
    setReachedEnd(isAccepted ? true : false);
    setScale(1);
    setIsLoading(true);
    setCurrentPdfUrl(fetchPdfFromNextJs && isAccepted ? null : pdfUrl);
  }, [pdfUrl, isAccepted, fetchPdfFromNextJs]);

  // The acknowledgment is the electronic signature, so the person has to check it
  // themselves (Tiffaney, 2026-10-09). Reaching the end of the document only unlocks
  // the checkbox; it never checks it.

  const handleZoomIn = useCallback(() => {
    setScale((prev) => Math.min(prev + 0.2, 3));
  }, []);
  const handleZoomOut = useCallback(() => {
    setScale((prev) => Math.max(prev - 0.2, 0.5));
  }, []);

  return (
    // zIndex 2100: this modal is a child of View Contracts, which already uses
    // 2000. The MUI default (1300) placed the PDF behind the contracts list and
    // its backdrop, making it impossible to read or close. In onboarding there
    // is no parent modal, so 2100 remains safely on top.
    <Modal open={open} onClose={onClose} sx={{ zIndex: 2100 }}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: 24,
          borderRadius: "16px",
          padding: "20px",
          border: "2px solid #D175B6",
          backgroundColor: "#000",
          zIndex: 9,
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          // width: "calc(95vh / 1.414)",
          maxWidth: "90vw",
          maxHeight: "95vh",
          width: "min(950px, 90vw)",
          // height: "90vh",

          "@media (max-width: 900px)": {
            width: "95vw",
            // height: "92vh",
          },

          "@media (max-width: 600px)": {
            width: "97vw",
            maxWidth: "97vw",
            maxHeight: "96vh",
            padding: "12px",
            gap: "0.75rem",
          },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "1rem",
            flexShrink: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "1rem", sm: "1.5rem" },
              fontWeight: 500,
              flex: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {titleName}
          </Typography>
          <CustomIconButtonForSheet
            sx={{ backgroundColor: "transparent !important", flexShrink: 0 }}
            onClick={onClose}
          >
            <Close />
          </CustomIconButtonForSheet>
        </Box>

        {/* PDF area wrapper — position:relative so the download btn anchors here */}
        <Box
          onMouseEnter={() => setShowDownload(true)}
          onMouseLeave={() => setShowDownload(false)}
          sx={{
            position: "relative",
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Scrollable PDF */}
          <Box
            ref={containerRef}
            onScroll={handleScroll}
            onTouchEnd={handleTouchEnd}
            sx={{
              flex: 1,
              overflowY: "auto",
              overflowX: "auto",
              textAlign: "center",
              minHeight: 0,
            }}
            className="custom-scroll-design"
          >
            {isLoading && (
              <Box
                sx={{
                  position: "relative",
                  height: "100dvh",
                  width: "100%",
                }}
              >
                <LoadingOverlay open />
              </Box>
            )}
            <Box
              sx={{
                display: "inline-block",
                transformOrigin: "top center",
                transition: "transform 0.12s ease",
              }}
            >
              <Document
                file={currentPdfUrl}
                externalLinkTarget="_blank"
                error={
                  <Typography sx={{ color: "#fff", padding: "2rem" }}>
                    Failed to load the document. Please refresh the page or
                    contact support.
                  </Typography>
                }
                onLoadError={(e) => {
                  console.error("PDF Error", e);
                  setIsLoading(false);
                }}
                onLoadSuccess={onDocumentLoadSuccess}
              >
                {Array.from(new Array(numPages), (_, index) => (
                  <Page key={index} pageNumber={index + 1} scale={scale} />
                ))}
              </Document>
            </Box>
          </Box>

          {/* Floating Download/zoom/in/out Button
              Anchored to the wrapper (not the scroll container),
              so it always stays at the bottom-right of the PDF area. */}
          <Box
            sx={{
              position: "absolute",
              bottom: "14px",
              right: "14px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              zIndex: 10,
              opacity: showDownload ? 1 : 0,
              transform: showDownload ? "scale(1)" : "scale(0.75)",
              transition: "opacity 0.2s ease, transform 0.2s ease",
              "@media (hover: none)": {
                opacity: 1,
                transform: "scale(1)",
              },
            }}
          >
            {/* Zoom In */}
            <Box onClick={handleZoomIn} title="Zoom In" sx={fabStyle}>
              <ZoomIn sx={{ color: "#fff", fontSize: "1.2rem" }} />
            </Box>

            {/* Zoom Out */}
            <Box onClick={handleZoomOut} title="Zoom Out" sx={fabStyle}>
              <ZoomOut sx={{ color: "#fff", fontSize: "1.2rem" }} />
            </Box>

            {/* Download */}
            <Box onClick={handleDownload} title="Download PDF" sx={fabStyle}>
              <Download sx={{ color: "#fff", fontSize: "1.2rem" }} />
            </Box>
          </Box>
          {!reachedEnd && !readOnly && (
            <Box
              onClick={() => {
                const el = containerRef.current;
                if (!el) return;
                el.scrollTo({
                  top: el.scrollHeight,
                  behavior: "smooth",
                });
              }}
              sx={{
                position: "absolute",
                bottom: "14px",
                left: "50%",
                transform: "translateX(-50%)",
                background: "rgba(0,0,0,0.7)",
                color: "#fff",
                padding: "8px 14px",
                borderRadius: "20px",
                fontSize: "0.8rem",
                cursor: "pointer",
                zIndex: 10,
                animation: "bounce 1.5s infinite",
                "@keyframes bounce": {
                  "0%, 100%": { transform: "translate(-50%, 0)" },
                  "50%": { transform: "translate(-50%, 6px)" },
                },
              }}
            >
              ↓ Scroll to read & accept
            </Box>
          )}
        </Box>

        {/* Checkbox */}
        <Box
          sx={{
            flexShrink: 0,
            display: readOnly ? "none" : "flex",
            position: "relative",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "0.5rem",
            opacity: !reachedEnd && !checkboxStatus ? 0.45 : 1,
            pointerEvents: !reachedEnd && !checkboxStatus ? "none" : "auto",
            transition: "opacity 0.3s ease",
            paddingBottom: "2rem",
          }}
        >
          <Checkbox
            sx={{ color: "white", flexShrink: 0, pt: "2px" }}
            checked={checkboxStatus}
            onChange={handleCheckboxClick}
          />
          <Typography
            sx={{
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
              lineHeight: 1.6,
            }}
          >
            By clicking checkbox, I acknowledge that I have read and understand
            this agreement (and any related policies, agreements, and
            acknowledgements), and I agree to be bound by its terms. I further
            agree that clicking "I Accept" constitutes my electronic signature.
          </Typography>

          <Button
            sx={{
              position: "absolute",
              right: "0",
              bottom: "0",
              height: "1.5rem",
              fontSize: "1rem",
              wdith: "400",
              ...(!checkboxStatus
                ? {
                    cursor: "not-allowed",
                    opacity: "0.75",
                  }
                : {}),
            }}
            onClick={() => {
              if (!checkboxStatus) return;
              continueClickHandler();
            }}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

DocAndContracts.propTypes = {
  contractorId: PropTypes.string,
  isParentWraperEnabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  currentDocument: PropTypes.object,
  hideTitle: PropTypes.bool,
  removePadding: PropTypes.bool,
};

DocAndContracts.ParentWrapper.propTypes = {
  isParentWraperEnabled: PropTypes.bool,
  submitHandler: PropTypes.func,
  children: PropTypes.any,
  isDisabled: PropTypes.bool,
};

DocAndContracts.ContractAcceptModal.propTypes = {
  open: PropTypes.bool,
  titleName: PropTypes.string,
  pdfUrl: PropTypes.string,
  updateCheckboxClick: PropTypes.func,
  isAccepted: PropTypes.bool,
  onClose: PropTypes.bool,
  readOnly: PropTypes.bool,
  fetchPdfFromNextJs: PropTypes.bool,
  pdfType: PropTypes.string,
  contractorId: PropTypes.string,
};
